<!-- 获取门禁 SN 码图文教程 -->
<template>
    <div class="page">
        <van-nav-bar
            title="获取门禁SN码"
            left-arrow
            fixed
            placeholder
            safe-area-inset-top
            @click-left="goBack"
        />

        <div class="content">
            <p class="intro">请按以下步骤获取查看 SN 码，并准确填写（区分大小写）。</p>

            <div
                v-for="item in steps"
                :key="item.step"
                class="step-block"
            >
                <p class="step-desc">步骤{{ item.step }}：{{ item.description }}</p>
                <img
                    class="step-img"
                    :src="item.src"
                    :alt="item.alt"
                />
            </div>
        </div>
    </div>
</template>

<script>
const STEP_DESCRIPTIONS = [
    '打开钉钉软件，进入工作台页面，点击【魔点门禁】选项，如下图所示：',
    '进入魔点门禁页面，点击【设备管理】选项，如下图所示：',
    '进入设备管理页面，选择对应的门禁设备，如下图所示：',
    '进入设备信息页面，滑动页面找到【系统信息】选项并点击，如下图所示：',
    '查看到SN码(可长按复制SN码)，如下图所示：',
]

function buildSteps() {
    const context = require.context('@/assets/snCodeImages', false, /\.png$/i)
    return context
        .keys()
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
        .map((key, index) => {
            const step = index + 1
            return {
                step,
                description: STEP_DESCRIPTIONS[index] || '',
                src: context(key),
                alt: `获取门禁SN码步骤${step}`,
            }
        })
}

export default {
    name: 'SnCodeDoc',
    data() {
        return {
            steps: buildSteps(),
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
    },
}
</script>

<style scoped>
.page {
    min-height: 100vh;
    background: #eef3f9;
    box-sizing: border-box;
    padding-bottom: calc(0.4rem + env(safe-area-inset-bottom));
}

.content {
    padding: 0.28rem 0.28rem 0.32rem;
    box-sizing: border-box;
}

.intro {
    margin: 0 0 0.24rem;
    padding: 0.24rem 0.28rem;
    background: #ffffff;
    border-radius: 0.24rem;
    font-size: 0.26rem;
    line-height: 1.5;
    color: #5a6f8a;
    box-shadow: 0 0.06rem 0.2rem rgba(40, 90, 160, 0.06);
}

.step-block {
    margin-bottom: 0.24rem;
    padding: 0.24rem 0.28rem 0.28rem;
    background: #ffffff;
    border-radius: 0.24rem;
    box-shadow: 0 0.06rem 0.2rem rgba(40, 90, 160, 0.06);
    box-sizing: border-box;
}

.step-block:last-child {
    margin-bottom: 0;
}

.step-desc {
    margin: 0 0 0.2rem;
    font-size: 0.28rem;
    line-height: 1.55;
    color: #1e3a5f;
}

.step-img {
    margin-top: 0.08rem;
    display: block;
    width: 100%;
    border-radius: 0.16rem;
    background: #f5f8fc;
}

.page ::v-deep .van-nav-bar {
    background: #ffffff;
}

.page ::v-deep .van-nav-bar .van-nav-bar__title {
    color: #1e3a5f;
    font-weight: 600;
}

.page ::v-deep .van-nav-bar .van-icon {
    color: #2b7de9;
}
</style>
